import React from 'react';
import { css } from 'linaria';
import { Typography } from 'fronton-react';

const style = css`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-150);
  &:last-of-type {
    margin-bottom: var(--space-100);
  }
`;

type Props = {
  title: string;
  time: string;
};

export function OperationalTime({ title, time }: Props) {
  return (
    <div className={style}>
      <Typography variant="m" size="body_short">
        {title}
      </Typography>
      <Typography variant="m" size="body_short">
        {time}
      </Typography>
    </div>
  );
}
